import * as Icon from 'react-feather';

type FeatherType = {
  iconName: keyof typeof Icon;
  className?: string;
  size?: number; // optional
  style?: React.CSSProperties;
};

export default function FeatherIconCom({ iconName, className, size = 16, style }: FeatherType) {
  const IconComp = Icon[iconName];
  return <IconComp className={className} size={size} style={style} />;
}